import React, { useState, useEffect } from 'react';

// @context TGW-1769 メンバー一覧モーダル（Slack TTP: ヘッダの人数クリック→一覧）。
//   全体=サークル正会員全員 / チャンネル=参加メンバー。検索はFE側フィルタ（正会員規模なら十分）。
function MemberRow({ member, children }) {
  if (!member.member_id) {
    return <div className="slackch-members-row">{children}</div>;
  }
  return (
    <a className="slackch-members-row" href={`/member/profile/${member.member_id}`}>
      {children}
    </a>
  );
}

export default function ChannelMembersModal({ circleId, channel, onClose }) {
  const [members, setMembers] = useState(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    let aborted = false;
    (async () => {
      const params = new URLSearchParams({ circle_id: circleId });
      if (!channel.isGeneral && channel.id)
        params.append('message_group_id', channel.id);
      const res = await fetch(`/api/channels/members?${params}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (res.ok && !aborted) {
        const data = await res.json();
        setMembers(data.members || []);
      } else if (!aborted) {
        setMembers([]);
      }
    })();
    return () => {
      aborted = true;
    };
  }, [circleId, channel]);

  const q = query.trim().toLowerCase();
  const filtered = (members || []).filter(
    (m) =>
      !q ||
      (m.name || '').toLowerCase().includes(q) ||
      (m.tunagate_id || '').toLowerCase().includes(q),
  );

  return (
    <div className="slackch-modal-overlay" onClick={onClose}>
      <div className="slackch-modal" onClick={(e) => e.stopPropagation()}>
        <div className="slackch-modal-header">
          {channel.isPrivate ? '🔒' : '#'} {channel.name} のメンバー
          {members && (
            <span className="slackch-members-count">{members.length}人</span>
          )}
          <button
            type="button"
            className="slackch-modal-close"
            onClick={onClose}
            aria-label="閉じる"
          >
            ✕
          </button>
        </div>
        <div className="slackch-modal-body">
          <input
            className="slackch-modal-input"
            type="text"
            value={query}
            placeholder="名前で検索"
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className="slackch-members-list">
            {members === null && (
              <div className="slackch-pane-loading">読み込み中…</div>
            )}
            {members !== null && filtered.length === 0 && (
              <div className="slackch-pane-loading">
                該当するメンバーがいません
              </div>
            )}
            {filtered.map((m) => (
              // Slack TTP: メンバーカードクリックでプロフィールへ遷移（member_id が無い場合は非リンク）
              <MemberRow key={m.id} member={m}>
                {m.avatar_thumb ? (
                  <img src={m.avatar_thumb} alt="" />
                ) : (
                  <span className="slackch-members-avatar-fallback">
                    {(m.name || '?').charAt(0)}
                  </span>
                )}
                <span className="slackch-members-name">
                  {m.name}
                  {m.tunagate_id ? <small>@{m.tunagate_id}</small> : null}
                </span>
                {m.is_owner ? (
                  <span className="slackch-members-badge">オーナー</span>
                ) : m.is_manager ? (
                  <span className="slackch-members-badge slackch-members-badge--manager">
                    運営
                  </span>
                ) : null}
              </MemberRow>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
